import store from '../store';

const menuList = [{
	path: '/project_list',
	meta: {
		name: '项目管理',
		icon: 'tf-menu-project',
		role: '5,7,8'
	},
	component: () => import('@/pages/project/project_list')
}, {
	path: '/insurance_list',
	meta: {
		name: '保单管理',
		icon: 'tf-menu-insurance',
		role: '3,7'
	},
	component: () => import('@/pages/insurance/insurance_list')
}, {
	path: '/proceed_list',
	meta: {
		name: '开工令管理',
		icon: 'tf-menu-proceed',
		role: '7,8'
	},
	component: () => import('@/pages/proceed/proceed_list')
}, {
	path: '/contract_list',
	meta: {
		name: '合同管理',
		icon: 'tf-menu-contract',
		role: '7'
	},
	component: () => import('@/pages/contract/contract_list')
}, {
	path: '/ledger_list',
	meta: {
		name: '安全台账管理',
		icon: 'tf-menu-ledger',
		role: '7,8'
	},
	component: () => import('@/pages/ledger/ledger_list')
}, {
	path: '/claim_list',
	meta: {
		name: '理赔管理',
		icon: 'tf-menu-claim',
		role: '3,6'
	},
	component: () => import('@/pages/claim/claim_list')
}, {
	path: '/message',
	meta: {
		name: '消息中心',
		icon: 'tf-menu-message'
	},
	component: () => import('@/pages/message/index')
}]

export default [{
	path: '/',
	component: () => import('@/pages/home/index')
}, {
	path: '/login',
	meta: {
		title: '登录'
	},
	component: () => import('@/pages/login/index')
}, {
	path: '/mine',
	component: () => import('@/pages/home/mine')
}].concat(menuList).concat([{
	path: '/register',
	meta: {
		name: '账户资料完善'
	},
	component: () => import('@/pages/user/user_info_edit'),
	props: {
		register: true
	}
}, {
	path: '/notice',
	meta: {
		name: '政策与通知'
	},
	component: () => import('@/pages/notice/index')
}, {
	path: '/notice_detail',
	meta: {
		name: '政策与通知'
	},
	component: () => import('@/pages/notice/detail'),
	props: route => route.query
}, {
	path: '/project_edit',
	meta: {
		name: '项目编辑'
	},
	component: () => import('@/pages/project/project_edit'),
	props: route => route.query
}, {
	path: '/project_detail',
	meta: {
		name: '项目详情'
	},
	component: () => import('@/pages/project/project_detail'),
	props: route => route.query
}, {
	path: '/bidding_create',
	meta: {
		name: '新建中标项目'
	},
	component: () => import('@/pages/project/bidding_create')
}, {
	path: '/project_bidding',
	meta: {
		name: '设置中标企业'
	},
	component: () => import('@/pages/project/project_bidding'),
	props: route => route.query
}, {
	path: '/project_supervision',
	meta: {
		name: '加入项目'
	},
	component: () => import('@/pages/project/project_supervision')
}, {
	path: '/person_change_apply',
	meta: {
		name: '申请人员变更'
	},
	component: () => import('@/pages/project/person_change_apply'),
	props: route => route.query
}, {
	path: '/person_change_detail',
	meta: {
		name: '人员变更详情'
	},
	component: () => import('@/pages/project/person_change_detail'),
	props: route => route.query
}, {
	path: '/insurance_select',
	meta: {
		name: '保险办理'
	},
	component: () => import('@/pages/insurance/insurance_select'),
	props: route => route.query
}, {
	path: '/insurance_apply',
	meta: {
		name: '保险办理'
	},
	component: () => import('@/pages/insurance/insurance_apply'),
	props: route => route.query
}, {
	path: '/insurance_datum',
	meta: {
		name: '保险办理'
	},
	component: () => import('@/pages/insurance/insurance_datum'),
	props: route => route.query
}, {
	path: '/insurance_detail',
	meta: {
		name: '保单详情'
	},
	component: () => import('@/pages/insurance/insurance_detail'),
	props: route => route.query
}, {
	path: '/insurance_payment',
	meta: {
		name: '上传付款凭证'
	},
	component: () => import('@/pages/insurance/insurance_payment'),
	props: route => route.query
}, {
	path: '/proceed_apply',
	meta: {
		name: '申请开工令'
	},
	component: () => import('@/pages/proceed/proceed_apply'),
	props: route => route.query
}, {
	path: '/proceed_detail',
	meta: {
		name: '开工令详情'
	},
	component: () => import('@/pages/proceed/proceed_detail'),
	props: route => route.query
}, {
	path: '/contract_detail',
	meta: {
		name: '合同详情'
	},
	component: () => import('@/pages/contract/contract_detail'),
	props: route => route.query
}, {
	path: '/ledger_apply',
	meta: {
		name: '编辑安全台账'
	},
	component: () => import('@/pages/ledger/ledger_apply'),
	props: route => route.query
}, {
	path: '/ledger_detail',
	meta: {
		name: '安全台账详情'
	},
	component: () => import('@/pages/ledger/ledger_detail'),
	props: route => route.query
}, {
	path: '/claim_detail',
	meta: {
		name: '理赔详情'
	},
	component: () => import('@/pages/claim/claim_detail'),
	props: route => route.query
}, {
	path: '/user_info',
	meta: {
		name: '账号信息'
	},
	component: () => import('@/pages/user/user_info'),
	props: route => route.query
}, {
	path: '/user_info_edit',
	meta: {
		name: '编辑账号信息'
	},
	component: () => import('@/pages/user/user_info_edit'),
	props: route => route.query
}, {
	path: '/manual',
	meta: {
		name: '操作手册'
	},
	component: () => import('@/pages/manual/index')
}, {
	path: '/debug',
	meta: {
		name: 'debug'
	},
	component: () => import('@/pages/home/debug')
}, {
	path: '*',
	redirect: '/'
}])

export {menuList}